<template>
  <div class="absolute-calendar">
    <PmwHeading size="paragraph-60" weight="weight-medium" class="form--title">
      {{ roomName }}
    </PmwHeading>

    <div class="form--row">
      <PmwFormInput
        v-for="(val, index) in guestValues"
        v-model.number="guestValues[index].valor"
        :key="`input-${roomCode}-${val.tipoPax}-${index}`"
        :label="getInputLabel(val.numeroOcupantes, val.tipoPax)"
        :required="isRequired(guestValues)"
        :error="
          isRequired(guestValues) === true && guestValues[index].valor === null
        "
        data-error="PrecosQuartos"
        type="number"
        placeholder="100"
        sufix="R$"
        class="form--input"
        @input="handleData(guestValues, roomCode)"
      />
    </div>
  </div>
</template>

<script>
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import debounce from 'lodash.debounce'

export default {
  name: 'CoefficientPerDay',
  components: {
    PmwFormInput,
    PmwHeading
  },

  props: {
    /** Valores dos inputs por pessoa */
    guestValues: {
      type: Array,
      default: () => []
    },

    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Código do quarto */
    roomCode: Number,

    /** Nome do quarto */
    roomName: String,

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    /** Validar valor do coeficiente */
    handleData: debounce(function(value, roomCode) {
      if (this.fluctuationData.quartos === null) {
        this.fluctuationData.quartos = []
      }

      const totalFilled = []
      value.forEach((room) => {
        if (room.valor) {
          totalFilled.push(room)
        }
      })

      if (
        totalFilled.length === value.length &&
        !this.fluctuationData.quartos.includes(roomCode)
      ) {
        this.fluctuationData.quartos.push(roomCode)
      } else if (this.fluctuationData.quartos.includes(roomCode)) {
        const index = this.fluctuationData.quartos.indexOf(roomCode)
        this.fluctuationData.quartos.splice(index, 1)
      }
    }, 500),

    isRequired(guestValues) {
      const hasValue = guestValues.some((item) => item.valor)

      if (hasValue) {
        return true
      } else {
        return false
      }
    },

    /**
     * Retorna a label do input
     * @param {number} qnt quantidade do pax
     * @param {number} tipoPax tipo do pax
     */
    getInputLabel(qnt, tipoPax) {
      const term = tipoPax < 10 ? 'criança | crianças' : 'adulto | adultos'

      return `Valor para ${qnt} ${this.$options.filters.pluralizer(
        qnt,
        term,
        true
      )}`
    }
  }
}
</script>

<style scoped lang="scss">
.absolute-calendar {
  border: 1px solid pmw-colors(grey-20);
  padding: 12px 21px;
  width: 100%;
  .form {
    &--title {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-medium');
      line-height: 21px;
    }

    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 24px;
      margin-bottom: 18px;
    }

    &--input {
      width: 195px;

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }
  }
}
</style>
